export enum RoleTypes {
  MainAccount = 'mainaccount',
}

export interface ISubscriptionRoleResult {
  id: string;
  identityId: string;
  firstName: string;
  lastName: string;
  email: string;
  roleName: string;
}

export interface ISubscriptionSearchTerms {
  subscriptionId: string;
}
